<template>
    <Layout>
        <div slot="main" class="home-bg">
            <div class="error-block">
                <div class="img-area"><img src="../style/error_pic.png" alt=""></div>
                <div class="txt-area">
                    <p><img src="../style/404_pic.png" alt=""></p>
                    <p class="error-txt">Error</p>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/views/Layout.vue';

export default {
    name: 'error404',
    components: {
        Layout,
    },
    data() {
        return {};
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #fff;
    }
    .error-block {
        height: 603px;
        background: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0 auto;
        width: 582px;
        .img-area {
            margin-right: 32px;
            img {
                width: 276px;
                height: 292px;
            }
        }
        .txt-area {
            img {
                width: 220px;
                height: 126px;
            }
            .error-txt {
                margin-top: 10px;
                height:36px;
                font-size:36px;
                font-weight:600;
                color:#4A4A4A;
                line-height:36px;
                text-align: center;
            }
        }
    }
</style>
